export const viewModeTitle = 'Режим просмотра';
export const defaultModelTitle = 'Модель данных по умолчанию';
export const isRealDataTitle = 'Реальные данные';
export const fontSettingsTitle = 'Локальный шрифт';
export const showWorkSpaceTitle = 'Показать границы страницы';
export const gridSpacingTitle = 'Шаг сетки';
export const scaleOfPageTitle = 'Масштабирование страницы';
